
export const UNDISPATCH_ORDER= 'UNDISPATCH_ORDER'
export const UNDISPATCH_ORDER_SUCCESS= 'UNDISPATCH_ORDER_SUCCESS'
export const UNDISPATCH_ORDER_ERROR='UNDISPATCH_ORDER_ERROR'


export const UnDispatchOrder= (data) => ({
    type: UNDISPATCH_ORDER,
    payload: data
});